import type { Action } from "../../actions/types";

export interface Share {
  channel: string;
  recipient: string;
  shareId: string;
  sharedOn: string;
  status: "invited" | "pending" | "rejected" | "approved";
  resentStatus: boolean;
}

export type StoreState = Share[];

export const initialState = [];

export function reducer(
  state: StoreState | null = initialState,
  action: Action
): StoreState | null {
  if (action.type === "GET_SHARES_SUCCESS") {
    return action.response.data.shares;
  }

  if (action.type === "RESEND_SHARE_SUCCESS") {
    const shares = state ? [...state] : [];
    const share = action.response.data.share;
    const indexOfExistingShare = shares.findIndex(
      (existingShare) => existingShare.recipient === share.recipient
    );
    shares.splice(indexOfExistingShare, 1, share);

    return shares;
  }

  return state;
}
